export const ROUTES = {
  ROOT: '/',

  HOME: '/home',
  UNLOCK: '/unlock',

  // TOKENS
  TOKEN_DETAILS: (tokenId: string) => `/home/tokens/${tokenId}`,
  MINT_CK: (tokenId: string) => `/home/tokens/mint-ck/${tokenId}`,
  MANAGE_TOKENS: '/home/tokens/manage',

  // NFTS
  NFT_DETAILS: (nftCanisterId: string, tokenId: string) =>
    `/home/nfts/details/${nftCanisterId}/${tokenId}`,

  BACKUP_SEED: '/wallet/backup-seed',
  PEM_IMPORT: '/wallet/import-pem',
  STOIC_IMPORT: '/wallet/import-stoic',

  // MINT
  MINT: '/mint',
  MINT_BTC: '/mint-btc',

  // SEND
  SEND: '/home/send',
  SEND_REVIEW: '/home/send/review',

  // CONACTS
  CONTACTS: '/home/contacts',

  STAKE: '/home/stake',

  // TOPUP
  TOPUP: '/home/topup',
  TOPUP_HISTORY: '/home/topup/history',
  MINT_CYCLES: '/home/mint-cycles',
  APPROVE_CYCLES: '/home/approve-cycles',

  // SWAP
  SWAP: '/home/swap',
  SWAP_FALLBACK_PROVIDER_SELECT: '/home/swap/fallback/provider-select',
  SWAP_FALLBACK_PAIR_SELECT: '/home/swap/fallback/pair-select',
  ICPSWAP_FALLBACK_PAIR: '/home/swap/fallback/icpswap',

  // NFTS
  NFTS: '/nfts',
  NFT_OVERVIEW: '/nfts/overview',

  // CONTACTS
  CONTACT_DETAILS: (address: string) => `/home/contact/${address}`,

  ADDRESSES: '/home/addresses',

  // TRANSACTIONS
  TRANSACTIONS: '/transactions',
  TRANSACTION_DETAILS: (transactionId: string, tokenSymbol: string, tokenCanisterId: string) =>
    `/home/transactions/${tokenSymbol}/${tokenCanisterId}/${transactionId}`,

  SWAP_DETAILS: (tokenFromSymbol: string, tokenToSymbol: string) =>
    `/home/swaps/${tokenFromSymbol}/${tokenToSymbol}`,

  // TRANSACTIONS
  TOKENS: '/tokens',
  TOKEN_OVERVIEW: '/tokens/overview',
  TOKEN_MANAGER: '/tokens/manage',

  // DISCOVER
  DISCOVER: '/discover',
  DISCOVER_OVERVIEW: '/discover/overview',

  // CONVERT
  CONVERT: '/home/convert',
  CONVERT_RESULT: '/home/convert/result',

  // SETTINGS
  SETTINGS: '/settings',
  SETTINGS_CONTACTS: '/settings/contacts',
  SETTINGS_CONTACTS_EDIT: '/settings/contacts/edit',
  SETTINGS_NETWORKS: '/settings/networks',
  SETTINGS_HELP: '/settings/help',
  SETTINGS_RECOVERY_PHRASE: '/settings/recovery-phrase',
  SETTINGS_PEM_EXPORT: '/settings/pem-export',
  LOCALE_SETTINGS: '/settings/locale',

  // AUTH
  AUTHORIZE: '/authorize',

  ACCOUNTS: '/accounts',
  WALLET_IMPORT_TYPE: '/accounts/new-type',

  KEY_REVEAL_ACCEPTANCE: '/key-reveal-acceptance',
  CONNECTED_APPS: '/connected-apps',

  DEVELOPER_SETTINGS: '/settings/developer-settings',
  DEVELOPER_SETTINGS_NETWORKS: '/settings/developer-settings/networks',
  DEVELOPER_SETTINGS_NEW_NETWORK: '/settings/developer-settings/networks/new',
  DEVELOPER_SETTINGS_EDIT_NETWORK: (id: string) =>
    `/settings/developer-settings/network/${id}/edit`,

  LLM_CHAT: '/llm-chat',

  DEPOSIT_ODIN: '/deposit-odin',

  BRIDGE: '/bridge',
  BRIDGE_HISTORY: '/bridge/history',
}
